import React from 'react';

const ProgressBar = ({ currentStep, totalSteps, onBack }) => {
  return <div className='progress-bar'>
    <button className='progress-bar__back' onClick={() => onBack(currentStep - 1)}></button>
    <div className='progress-bar__bar'>
      <div className='progress-bar__bar__progress'
        style={{ width: `${(currentStep / totalSteps) * 100}%` }}>
      </div>
    </div>
  </div>;
};

export default ProgressBar;
